/** Marca que al montar el inicio debe ejecutarse el tour (enlace desde Ajustes). */
export const PRODUCT_TOUR_SESSION_KEY = "homeexpense:runProductTour";

export function markProductTourPending(): void {
  try {
    sessionStorage.setItem(PRODUCT_TOUR_SESSION_KEY, "1");
  } catch {
    /* private mode */
  }
}

export function peekProductTourPending(): boolean {
  try {
    return sessionStorage.getItem(PRODUCT_TOUR_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

/** Llamar justo antes de iniciar el tour (p. ej. dentro del `setTimeout`). */
export function clearProductTourPending(): void {
  try {
    sessionStorage.removeItem(PRODUCT_TOUR_SESSION_KEY);
  } catch {
    /* ignore */
  }
}
